(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["categorias"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('culto-expandable-categories')) {
  customElements.define('culto-expandable-categories', class extends HTMLElement {
    connectedCallback() { this.frame = requestAnimationFrame(() => this.setup()); }
    setup() {
      if (!this.isConnected || this.controller) return;
      this.tiles = [...this.querySelectorAll('.ce-tile')];
      this.overlay = this.querySelector('.ce-expanded');
      this.back = this.querySelector('.ce-back');
      this.select = this.querySelector('.ce-select');
      if (!this.tiles.length || !this.overlay) return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.fine = matchMedia('(hover:hover) and (pointer:fine)');
      this.tiles.forEach(tile => {
        tile.addEventListener('pointerenter', () => { if (this.fine.matches && !this.active && !this.hoverPaused && !window.Shopify?.designMode) this.open(tile.dataset.id); }, options);
        tile.addEventListener('click', () => { if (!this.active) this.open(tile.dataset.id, true); }, options);
      });
      this.addEventListener('pointerleave', () => { this.hoverPaused = false; if (this.fine.matches && this.active && !this.overlay.contains(document.activeElement)) this.close(); }, options);
      this.back.addEventListener('click', () => this.close(true), options);
      this.select.addEventListener('change', () => this.open(this.select.value), options);
      this.addEventListener('keydown', event => { if (event.key === 'Escape' && this.active) { event.preventDefault(); this.close(true); } }, options);
      this.addEventListener('focusout', () => queueMicrotask(() => { if (this.active && !this.contains(document.activeElement)) this.close(); }), options);
      document.addEventListener('shopify:block:select', event => { if (this.tiles.some(tile => tile.dataset.id === event.detail.blockId)) this.open(event.detail.blockId); }, options);
      document.addEventListener('shopify:block:deselect', event => { if (this.active === event.detail.blockId) this.close(); }, options);
      this.resize = new ResizeObserver(() => this.layout());
      this.resize.observe(this);
      this.layout();
    }
    layout() {
      const columns = this.tiles.length === 1 ? 1 : this.getBoundingClientRect().width <= 600 || this.tiles.length <= 4 ? 2 : 3;
      const rows = Math.ceil(this.tiles.length / columns);
      this.style.setProperty('--ce-rows', rows);
      this.tiles.forEach((tile,index) => {
        const start = Math.floor(index / columns) * columns;
        const rowCount = Math.min(columns, this.tiles.length - start);
        tile.style.setProperty('--ce-x', (index - start) * 100 / rowCount + '%');
        tile.style.setProperty('--ce-y', Math.floor(index / columns) * 100 / rows + '%');
        tile.style.setProperty('--ce-w', 100 / rowCount + '%');
        tile.style.setProperty('--ce-h', 100 / rows + '%');
      });
    }
    open(id, focus = false) {
      const tile = this.tiles.find(tile => tile.dataset.id === id);
      if (!tile) return;
      this.active = id; this.dataset.open = 'true';
      this.overlay.inert = false; this.overlay.setAttribute('aria-hidden','false');
      this.tiles.forEach(t => { t.classList.toggle('is-active', t === tile); t.setAttribute('aria-expanded',String(t === tile)); t.tabIndex = -1; });
      this.querySelector('.ce-info h3').textContent = tile.dataset.name;
      const link = this.querySelector('.ce-cta');
      link.hidden = !tile.dataset.url;
      if (tile.dataset.url) { link.href = tile.dataset.url; link.setAttribute('aria-label','Explorar ' + tile.dataset.name); } else { link.removeAttribute('href'); }
      this.select.value = id;
      if (focus) requestAnimationFrame(() => { if (this.isConnected && this.active === id) this.back.focus({preventScroll:true}); });
    }
    close(restore = false) {
      const previous = this.active; this.hoverPaused = restore;
      this.active = null; this.dataset.open = 'false'; this.overlay.inert = true; this.overlay.setAttribute('aria-hidden','true');
      this.tiles.forEach(tile => { tile.classList.remove('is-active'); tile.setAttribute('aria-expanded','false'); tile.tabIndex = 0; });
      if (restore) this.tiles.find(tile => tile.dataset.id === previous)?.focus({preventScroll:true});
    }
    disconnectedCallback() { cancelAnimationFrame(this.frame); this.controller?.abort(); this.controller = null; this.resize?.disconnect(); }
  });
}

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["popupprelanzamiento"] && !Shopify.designMode) return;
  try {
    
if (!customElements.get('culto-home-popup')) {
  customElements.define('culto-home-popup', class extends HTMLElement {
    connectedCallback() {
      this.frame = requestAnimationFrame(() => this.setup());
    }
    setup() {
      if (!this.isConnected || this.controller) return;
      this.dialog = this.querySelector('dialog');
      if (!this.dialog || typeof this.dialog.showModal !== 'function') return;
      this.controller = new AbortController();
      const options = { signal: this.controller.signal };
      this.querySelectorAll('button').forEach(button => button.addEventListener('click', () => this.dialog.close(), options));
      this.dialog.addEventListener('close', () => this.restore(), options);
      this.dialog.addEventListener('keydown', event => {
        if (event.key !== 'Tab') return;
        const controls = [...this.dialog.querySelectorAll('button:not([disabled]), a[href]')];
        const first = controls[0], last = controls[controls.length - 1];
        if (event.shiftKey && document.activeElement === first) {
          event.preventDefault(); last.focus();
        } else if (!event.shiftKey && document.activeElement === last) {
          event.preventDefault(); first.focus();
        }
      }, options);
      this.dialog.addEventListener('pointerdown', event => { this.backdropStart = event.target === this.dialog && this.outside(event); }, options);
      this.dialog.addEventListener('click', event => {
        if (this.backdropStart && event.target === this.dialog && this.outside(event)) this.dialog.close();
        this.backdropStart = false;
      }, options);
      // Keep the theme editor usable; selecting the section must not trap its controls.
      if (this.dataset.editor === 'true' || window.Shopify?.designMode) return;
      const sessionOnly = this.dataset.frequency !== 'always';
      try { if (sessionOnly && sessionStorage.getItem(this.dataset.key)) return; } catch (_) { /* Storage may be disabled. */ }
      this.timer = setTimeout(() => {
        if (!this.isConnected || document.querySelector('dialog[open]')) return;
        if (window.__cultoHomePopupShown) return;
        this.previousFocus = document.activeElement;
        this.dialog.showModal();
        window.__cultoHomePopupShown = true;
        this.previousOverflow = document.documentElement.style.overflow;
        document.documentElement.style.overflow = 'hidden';
        this.locked = true;
        try { if (sessionOnly) sessionStorage.setItem(this.dataset.key, '1'); } catch (_) { /* The dialog still works without storage. */ }
      }, Math.max(0, Number(this.dataset.delay) || 0));
    }
    outside(event) {
      const rect = this.dialog.getBoundingClientRect();
      return event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom;
    }
    restore() {
      if (this.locked) {
        document.documentElement.style.overflow = this.previousOverflow;
        this.locked = false;
      }
      if (this.previousFocus?.isConnected && typeof this.previousFocus.focus === 'function') this.previousFocus.focus({ preventScroll: true });
      this.previousFocus = null;
    }
    disconnectedCallback() {
      cancelAnimationFrame(this.frame);
      clearTimeout(this.timer);
      this.controller?.abort();
      this.controller = null;
      if (this.dialog?.open) this.dialog.close();
      this.restore();
    }
  });
}


  } catch(e) { console.error(e); }
})();
})();
